import { fetchWithRetry } from '../../Transactions/utils/fetchHelper';
import { getDepositStatusForCuentita } from '../utils/movementHelpers';
import { fetchMonthlyDepositsSum } from './depositService';

/**
 * Determina el tipo de cuenta basado en flags de localStorage
 * @returns {string|null}
 */
export const computeAccountType = () => {
    const currentIsAccount = localStorage.getItem('is_account') === 'true';
    const currentIsAggregator = localStorage.getItem('is_aggregator') === 'true';

    if (currentIsAggregator && currentIsAccount) return "Concentradora";
    if (!currentIsAggregator && !currentIsAccount) return "Cuentita";
    if (!currentIsAggregator && currentIsAccount) return "Cuenta Actual";
    return null;
};

/**
 * Obtiene la lista de depósitos con paginación
 * @param {Object} config - Configuración de la petición
 * @returns {Promise<Object>} - { data, totalPages, error }
 */
export const fetchDepositos = async (config) => {
    const { accessToken, bpToken, accountType, page, limit = 100 } = config;
    const apiUrl = process.env.REACT_APP_API_URL_DEV;
    
    let requestUrl;
    let headers = { 'authorization': accessToken };

    if (accountType === "Cuentita" || accountType === "Concentradora") {
        requestUrl = `${apiUrl}/api/v2/depositos?page=${page}&limit=${limit}`;
    } else if (accountType === "Cuenta Actual") {
        if (!bpToken) throw new Error('MISSING_BP_TOKEN');
        requestUrl = `${apiUrl}/depositos?page=${page}&limit=${limit}`;
        headers['bp-token'] = bpToken;
    } else {
        throw new Error('INVALID_ACCOUNT_TYPE');
    }

    const response = await fetchWithRetry(requestUrl, { method: 'GET', headers });

    if (response.status === 401) return { error: 'UNAUTHORIZED', status: 401 };
    if (!response.ok) throw new Error(`API_ERROR_${response.status}`);

    const data = await response.json();
    let processedDepositos = [];
    let totalPages = 1;

    if (accountType === "Cuentita" && data) {
        processedDepositos = data.data || [];
        totalPages = data.total_pages || 1;
    } else {
        processedDepositos = data.Data || data || [];
        totalPages = 1; // Ajustar si la API V1 soporta paginación explícita
    }

    return {
        data: processedDepositos,
        totalPages
    };
};



/**
 * Obtiene el resumen mensual de depósitos
 * @param {Object} config - Configuración (accessToken, bpToken, accountType)
 * @returns {Promise<number>}
 */
export const fetchMonthlySum = async (config) => {
    const { accessToken, bpToken, accountType } = config;
    return await fetchMonthlyDepositsSum(accessToken, bpToken, accountType);
};

